import React, { useRef, useState } from "react";
import start from "../../images/Star.svg";
import { Link, useHistory } from "react-router-dom";
import invitation from "../../images/invitations.svg";
import regestration from "../../images/registration.svg";
import rewards from "../../images/rewards.svg";
import { Overlay, Tooltip } from "react-bootstrap";
import UploadCSV from "../Popup/UploadCSV";
import MultiEmail from "./MultiEmail";
import { useQuery } from "@apollo/react-hooks";
import { GET_REFFERAL } from "../../query/getReferral";
import { hasuraClient } from "../../apolloClient";
import moment from "moment";
import { GET_REFFERAL_LINK } from "../../query/getReferalLink";
import ReferralSuccessModal from "../Common/SuccessModal";

const Referrals = () => {
  const [modalShow, setModalShow] = React.useState(false);
  const [isInviteSuccess, setIsInviteSuccess] = React.useState(false);
  const [currentFile, setCurrentFile] = useState(null);

  const [show, setShow] = useState(false);
  const target = useRef(null);

  const history = useHistory();

  const { data: referralData } = useQuery(GET_REFFERAL, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
    variables: {
      user_id: localStorage.getItem("user_id"),
      type: "business",
    },
  });

  const { data: referralLinkData } = useQuery(GET_REFFERAL_LINK, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });

  function myFunction() {
    setShow(true);

    var copyText = document.getElementById("copy-text");

    copyText.select();
    copyText.setSelectionRange(0, 99999);

    navigator.clipboard.writeText(copyText.value);
    setTimeout(() => {
      setShow(false);
    }, 2000);
  }

  return (
    <>
      <ReferralSuccessModal
        show={isInviteSuccess}
        setIsPostSuccess={setIsInviteSuccess}
        onHide={() => {
          setIsInviteSuccess(false);
          history.push("/settings/referrals");
        }}
        message="We have just sent an invitation to join 
          Whatzon by email."
      />
      <div className="referrals-block">
        <div className="referrals-row">
          <div className="main-title">
            <h3>Referrals</h3>
            <p>
              Invite other businesses to WhatzOn and gain the benefits! Here’s
              how it’ll work:
            </p>
          </div>
          <div className="referrals-view-block">
            <div className="referral-view-left">
              <div className="icon">
                <img src={start} alt="icon" />
              </div>
              <h2> {referralData?.referral_programs[0]?.title} </h2>
              <p>
                Expires{" "}
                {referralData &&
                referralData.referral_programs &&
                referralData.referral_programs.length
                  ? moment(
                      referralData.referral_programs[0].end_date_time
                    ).format("MMMM DD, YYYY")
                  : ""}{" "}
              </p>
            </div>
            <div className="referral-view-right">
              <Link to="/referrals-details">View details</Link>
            </div>
          </div>
          <ul className="referrals-types">
            <li>
              <div className="referrals-types-cover">
                <div className="icon">
                  <img src={invitation} alt="send invitations" />
                </div>
                <h2>Send Invitations</h2>
                <p>Share your unqiue referral link with other businesses</p>
              </div>
            </li>
            <li>
              <div className="referrals-types-cover">
                <div className="icon">
                  <img src={regestration} alt="send invitations" />
                </div>
                <h2>Registration</h2>
                <p>
                  Let them register their business to WhatzOn with the link you
                  shared
                </p>
              </div>
            </li>
            <li>
              <div className="referrals-types-cover">
                <div className="icon">
                  <img src={rewards} alt="send invitations" />
                </div>
                <h2>Receive Rewards</h2>
                <p>
                  Your business will receive rewards for every registration!
                </p>
              </div>
            </li>
          </ul>
          <div className="business-invite">
            <div className="main-title">
              <h3>Invite other businesses</h3>
              <p>
                Enter email addreses or upload a CSV file to send them
                invitations to join WhatzOn. We will automatically filter
                duplicate emails.
              </p>
            </div>
            <MultiEmail setIsInviteSuccess={setIsInviteSuccess} />
            <div className="upload-csv-block">
              <div className="upload-btn">
                <button
                  className="primary-button"
                  onClick={() => {
                    setModalShow(true);
                    setCurrentFile(null);
                  }}
                >
                  Upload CSV
                </button>
                <UploadCSV
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                  setModalShow={setModalShow}
                  setIsInviteSuccess={setIsInviteSuccess}
                  setCurrentFile={setCurrentFile}
                  currentFile={currentFile}
                />
              </div>
            </div>
          </div>
          <div className="main-title">
            <h3>Share the referral link</h3>
            <p>
              You can share your referral link by copying and sending it or
              sharing it on your social media and other platforms
            </p>
          </div>
          <div className="link-block">
            <a
              href={
                window.location.origin +
                "/referral-invite/" +
                referralLinkData?.referral_links[0]?.referral_id
              }
              target="_blank"
            >
              {window.location.host +
                "/referral-invite/" +
                referralLinkData?.referral_links[0]?.referral_id}
            </a>
            <input
              type="text"
              value={
                window.location.origin +
                "/referral-invite/" +
                referralLinkData?.referral_links[0]?.referral_id
              }
              id="copy-text"
              style={{ display: "none" }}
            />
            <button
              className="button"
              onClick={() => {
                myFunction();
              }}
              ref={target}
            >
              Copy link
            </button>

            <Overlay target={target.current} show={show} placement="left">
              {(props) => (
                <Tooltip id="overlay-example" {...props}>
                  Link copied to clipboard!
                </Tooltip>
              )}
            </Overlay>
          </div>
        </div>
      </div>
    </>
  );
};

export default Referrals;
